import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 4D922F91-E62D-42BB-86E4-BE8A96BC2B80
 * name diamond-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/diamond-outline.svg
 * tags
 */
export const DiamondOutlineIcon = createSvgIcon(<><path d="M18,2H6L2,8L12,22L22,8L18,2M4.43,8L7.07,4H16.93L19.57,8L12,18.56L4.43,8Z" /></>, 'DiamondOutlineIcon');
export default DiamondOutlineIcon